module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 86
// module chunks = 0